import { Button, ButtonGroup } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';

type ChatType = 'duke-support' | 'participant';

type ChatTypeSelectorProps = {
  value: ChatType;
  onChange: (type: ChatType) => void;
};

export function ChatTypeSelector({ value, onChange }: ChatTypeSelectorProps) {
  return (
    <ButtonGroup isAttached variant="outline" size="xs">
      <Button
        onClick={() => onChange('duke-support')}
        variant={value === 'duke-support' ? 'solid' : 'outline'}
        colorScheme={value === 'duke-support' ? 'blue' : 'gray'}
      >
        <Trans>Duke Support</Trans>
      </Button>
      <Button
        onClick={() => onChange('participant')}
        variant={value === 'participant' ? 'solid' : 'outline'}
        colorScheme={value === 'participant' ? 'blue' : 'gray'}
      >
        <Trans>Participant</Trans>
      </Button>
    </ButtonGroup>
  );
}
